/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from "react";

import { documentToHtmlString } from "@contentful/rich-text-html-renderer";
import { Document } from "@contentful/rich-text-types";

import { TutorialIntroduction } from "@/templates/agile-hub/tutorial-types";

import {
    TutorialIntroductionContent,
    UniformTutorialIntroductionContentProps
} from "./src/tutorial-introduction-content";

export type { UniformTutorialIntroductionContentProps } from "./src/tutorial-introduction-content";

export const format = (
    body: UniformTutorialIntroductionContentProps
): TutorialIntroduction => {
    if (!body)
        return {
            tutorialIntroductionName: null,
            tutorialIntroductionDetails: null,
            tutorialIntroductionAsset: null,
            embedLink: null
        };

    const { tutorialintroduction }: any = body;

    function getRichText(richText: string | Document) {
        if (typeof richText === "string") {
            return richText;
        }

        return documentToHtmlString(richText);
    }

    const formattedBody: TutorialIntroduction = {
        tutorialIntroductionName:
            tutorialintroduction?.tutorialIntroductionTitleExternal ?? null,
        tutorialIntroductionDetails:
            getRichText(tutorialintroduction?.tutorialIntroductionDetails) ??
            null,
        tutorialIntroductionAsset:
            formatAsset(tutorialintroduction?.tutorialIntroductionAsset) ??
            null,
        embedLink: tutorialintroduction?.embedLink ?? null
    };

    return formattedBody;
};

// eslint-disable-next-line complexity
const formatAsset = (asset: any) => {
    if (!asset?.fields) return undefined;

    const { fields } = asset;
    return {
        name: fields.title,
        size: fields.file?.details?.size,
        fileName: fields.file?.fileName ?? null,
        height: fields.file?.image?.height ?? null,
        width: fields.image?.width ?? null,
        url: fields.file?.url,
        description: fields.description ?? null,
        contentType: fields.file?.contentType ?? null
    };
};

const UniformTutorialIntroductionContent = (
    props: UniformTutorialIntroductionContentProps
) => {
    const tutorialIntroduction = useMemo(() => format(props), [props]);

    return (
        <TutorialIntroductionContent
            tutorialIntroduction={tutorialIntroduction}
        />
    );
};

export default UniformTutorialIntroductionContent;
